import React, { Component } from 'react';
import { Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { Input as FormInput } from '../../Form';
import './TaglineCard.css';
import {
  withInputClassNames,
  withTextAreaClassNames,
} from './../../EditProfile/HOC';

const Input = withInputClassNames(FormInput);
const TextArea = withTextAreaClassNames(FormInput);

class TaglineCard extends Component {
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.values, this.props.values)) {
      this.send();
    }
  }

  send = debounce(() => {
    const { values, errors } = this.props;
    this.props.handleInputChange({ values, errors });
  }, 300);

  render() {
    return (
      <div className="col-12 col-lg-7 mx-auto">
        <Form className="bg-white shadow-card p-5">
          <Input label="Tagline (40 characters max)" name="tagline" />
          <TextArea label="Bio" name="bio" type="textArea" minHeight={170.22} />
        </Form>
      </div>
    );
  }
}

TaglineCard.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleInputChange: PropTypes.func,
};

export default withFormik({
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: true,
  displayName: 'TaglineCardForm',
})(TaglineCard);



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolio/TaglineCard/TaglineCard.js